import React from 'react';
import { TRANSFER_STEPS } from '../../config/cctp/constants';
import { CHAIN_TO_CHAIN_NAME } from '../../config/cctp/chains';

const TransferProgress = ({ currentStep, txHashes, destinationChain = 43114 }) => {
  const destinationName = CHAIN_TO_CHAIN_NAME[destinationChain] || 'Destination';
  
  const steps = [
    { key: TRANSFER_STEPS.APPROVING, label: 'Approving USDC', icon: '🔓' },
    { key: TRANSFER_STEPS.BURNING, label: 'Burning USDC', icon: '🔥' },
    { key: TRANSFER_STEPS.WAITING_ATTESTATION, label: 'Waiting for Attestation', icon: '⏳' },
    { key: TRANSFER_STEPS.READY_TO_MINT, label: 'Ready to Mint', icon: '✨' },
    { key: TRANSFER_STEPS.MINTING, label: `Minting on ${destinationName}`, icon: '💎' },
    { key: TRANSFER_STEPS.COMPLETED, label: 'Transfer Complete', icon: '✅' },
  ];

  const getStepStatus = (stepKey) => {
    const stepOrder = [
      TRANSFER_STEPS.APPROVING,
      TRANSFER_STEPS.BURNING,
      TRANSFER_STEPS.WAITING_ATTESTATION,
      TRANSFER_STEPS.READY_TO_MINT,
      TRANSFER_STEPS.MINTING,
      TRANSFER_STEPS.COMPLETED,
    ];

    const currentIndex = stepOrder.indexOf(currentStep);
    const stepIndex = stepOrder.indexOf(stepKey);

    if (currentStep === TRANSFER_STEPS.ERROR) {
      return currentIndex >= stepIndex ? 'error' : 'pending';
    }

    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'active';
    return 'pending';
  };

  const getExplorerUrl = (chainId, txHash) => {
    const explorers = {
      1: 'https://etherscan.io/tx/',
      43114: 'https://snowtrace.io/tx/',
      10: 'https://optimistic.etherscan.io/tx/',
      42161: 'https://arbiscan.io/tx/',
      8453: 'https://basescan.org/tx/',
      137: 'https://polygonscan.com/tx/',
    };
    
    return explorers[chainId] ? `${explorers[chainId]}${txHash}` : null;
  };

  return (
    <div className="transfer-progress">
      <h3>Transfer Progress</h3>
      <div className="progress-steps">
        {steps.map((step, index) => {
          const status = getStepStatus(step.key);
          return (
            <div key={step.key} className={`progress-step ${status}`}>
              <div className="step-icon">{step.icon}</div>
              <div className="step-content">
                <div className="step-label">{step.label}</div>
                {step.key === TRANSFER_STEPS.BURNING && txHashes.burn && (
                  <a 
                    href={getExplorerUrl(1, txHashes.burn)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="tx-link"
                  >
                    View Burn TX
                  </a>
                )}
                {step.key === TRANSFER_STEPS.READY_TO_MINT && currentStep === TRANSFER_STEPS.READY_TO_MINT && (
                  <div className="ready-to-mint-message">
                    Attestation received! Use the "Mint USDC" button in Transaction History to complete.
                  </div>
                )}
                {step.key === TRANSFER_STEPS.COMPLETED && txHashes.mint && (
                  <a 
                    href={getExplorerUrl(destinationChain, txHashes.mint)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="tx-link"
                  >
                    View Mint TX
                  </a>
                )}
              </div>
              {index < steps.length - 1 && <div className="step-connector" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransferProgress;